// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prizeData .el-pagination[data-v-1ad39b40] {\n  margin-top: 20px;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
